<template>
  <v-app-bar
    v-if="notification.show"
    color="#e21b23"
    height="72"
    style="z-index: 6"
    fixed
    flat
  >
    <v-row no-gutters>
      <v-col
        class="
          align-center
          font-size-md-res
          d-flex
          justify-center
          text-center
          color-white
        "
        >{{ notification.message }}

        <v-btn
          class="valign"
          color="white"
          @click="$store.commit('notification/HIDE')"
          icon
        >
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-col>
    </v-row>
  </v-app-bar>
</template>

<script>
import { mapState } from "vuex";

export default {
  name: "AppBarNotification",
  computed: {
    ...mapState({
      notification: (state) => state.notification,
    }),
  },
};
</script>
<style scoped>
.valign {
  position: absolute;
  right: 0;
  transform: translateY(-50%);
  top: 50%;
}
</style>
